import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import { useEffect, useMemo, useState, useCallback } from 'react';
import { useFormState } from 'react-final-form';
import { useDispatch } from 'react-redux';

import QCXAutocompleteSelectWithSearch from '../../../../../shared-components/autocomplete-select/QCXAutocompleteSelectWithSearch';
import { fetchByNumeroAsync } from '../../../../../features/follow-up/followUpThunks';

export default function QCXSelectFollowUpImportacaoWithSearchField({
  label,
  name,
  disabled,
  ...restProps
}) {
  const dispatch = useDispatch();
  const { values } = useFormState();

  const [options, setOptions] = useState([]);
  const [emptyListMsg, setEmptyListMsg] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);

  const importadorId = values?.importador?.id;
  const valorAtual = _.get(values, name);

  const filterPredicateProdutosFaturaveis = useCallback((followUp) => {
    const produto = followUp?.servico?.produto?.toUpperCase();
    return produto === 'IMPORTACAO' || produto === 'EXPORTACAO' || produto === 'ASSESSORIA';
  }, []);

  useEffect(() => {
    if (!importadorId) {
      setOptions([]);
      setDefaultValue(null);
      setEmptyListMsg('');
    }
  }, [importadorId]);

  useEffect(() => {
    const found = options.find((item) => String(item?.id) === String(valorAtual));

    if (found) {
      setDefaultValue(found);
    } else {
      setDefaultValue(null);
    }
  }, [options, valorAtual]);

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        stringify: (item) => `${item?.numero || ''}`,
      }),
    []
  );

  const handleSearchFollowUp = useCallback(
    async (value) => {
      const valorDigitado = String(value || '').trim();

      if (!importadorId) {
        setOptions([]);
        return;
      }

      if (valorDigitado.length < 4) {
        setOptions([]);
        setEmptyListMsg('Digite no mínimo 4 dígitos para pesquisar');
        return;
      }

      const action = await dispatch(
        fetchByNumeroAsync({
          numero: valorDigitado,
          importadorId,
        })
      );

      const data = action?.payload?.response?.data || [];
      const filtered = Array.isArray(data) ? data.filter(filterPredicateProdutosFaturaveis) : [];

      setOptions(filtered);
      setEmptyListMsg(filtered.length ? '' : 'Nenhum followup encontrado');
    },
    [dispatch, importadorId, filterPredicateProdutosFaturaveis]
  );

  return (
    <QCXAutocompleteSelectWithSearch
      label={label}
      id={name}
      name={name}
      onEventActionPaiFunction={handleSearchFollowUp}
      options={options}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.id ? `${item?.numero || ''}` : '')}
      getOptionSelected={(option, value) => String(option?.id) === String(value?.id)}
      emptyListMsg={emptyListMsg}
      placeholder="Digite no mínimo 4 dígitos para realizar a busca!"
      disabled={disabled || !importadorId}
      {...restProps}
    />
  );
}